export const finance = {
  data() {
    return {}
  },
  computed: {
    showPrice() {
      let price = this.item.seria.price;
      return this.checkProc(price);
    },
    getUserPrepay(){
      if(this.user){
        return this.user.property.prepay;
      } else {
        return 1;
      }
    },
  },
  methods: {

    returnPrice(price){
      return this.checkProc(price);
    },
    checkProc(price){
      if (this.prepay == 0) {
        return price;
      } else {
        return Math.round(price - this.percent(price, 10));
      }
    },
    percent(cif, val) {
      return 0; // отключил скидки
      let percent = val;
      return cif / 100 * percent;
    }
  }
};


// WEBPACK FOOTER //
// ./themes/oprava/src/js/components/mixins/finance.js